import React from 'react';
import { Footer } from '@guildeducationinc/recess';
import { trackEvent } from 'src/services/analytics';
import { CONTACT_SUPPORT_URL, HELP_CENTER_URL } from 'src/utilities/envConfig';

export const FooterContainer: React.FC = () => {
	const columns = () => [
		{
			title: 'Contact Us',
			links: [
				{
					onClick: () =>
						trackEvent('Clickable', {
							tag: 'nav_help_center',
							text: 'Help Center',
							type: 'link',
						}),
					href: HELP_CENTER_URL,
					label: 'Help Center',
					id: 'help-center',
				},
				{
					onClick: () =>
						trackEvent('Clickable', {
							tag: 'nav_contact_a_coach',
							text: 'Message Guild Support',
							type: 'link',
						}),
					href: CONTACT_SUPPORT_URL,
					label: 'Message Guild Support',
					id: 'message-guild-support',
				},
			],
		},
	];

	return <Footer className='footer' columns={columns()} />;
};
